import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Toast from '../ui/Toast';

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="flex-grow pt-24 pb-16 min-h-[80vh]">
        {children}
      </main>
      <Footer />
      <Toast />
    </>
  );
};

export default Layout;